export type AccessType = {
  [name: string]: string;
};

export const accessTypes: AccessType = {
  ADMIN: 'Administrador',
  GROUP: 'Grupo Econômico',
  HEAD_OFFICE: 'Matriz',
  BRANCH: 'Filial',
};
